import { Badge, CheckmarkBackgroundIcon } from '@paypalcorp/pp-react';
import React from 'react';
import PropTypes from 'prop-types';

const PreApprovalBadge = ({ text }) => (
  <Badge type="success" leftIcon={CheckmarkBackgroundIcon}>
    {text}
  </Badge>
);

PreApprovalBadge.propTypes = {
  text: PropTypes.string.isRequired,
};

export default PreApprovalBadge;
